/**
 * 自由入力の欄に、使い方の例を数秒おきに下からスライドインで出す（プレースホルダーの代わり）
 *
 * textarea の placeholder はアニメーションできないので、欄の上に重ねる（押せない・読み上げない）。
 * 入力欄にフォーカスがある間は切り替えを止める。動きを減らす設定では、アニメーションしない。
 * スマホでは少し小さい字にする（入力欄そのものの字は iOS の自動拡大を避けるため 16px のまま）。
 */

import { useEffect, useState } from 'react';
import { CHAT_INPUT_EXAMPLES, CHAT_INPUT_EXAMPLE_INTERVAL_MS } from '@/constants/chat';

function shuffled(items: readonly string[]): string[] {
  const copy = [...items];
  for (let i = copy.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}

export default function ChatInputExamples({ paused }: { paused: boolean }) {
  // 開くたびに並びを変える（いつも同じ例から始まらないように）
  const [examples] = useState(() => shuffled(CHAT_INPUT_EXAMPLES));
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (paused) return undefined;
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % examples.length);
    }, CHAT_INPUT_EXAMPLE_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, [paused, examples.length]);

  return (
    // textarea の枠線 1px＋余白（px-3・py-2）に合わせて、1 行目の位置に重ねる
    <span
      aria-hidden="true"
      className="pointer-events-none absolute left-[13px] right-[13px] top-[9px] h-6 overflow-hidden text-sm leading-6 text-text-400 sm:text-base"
    >
      <span
        key={index}
        className="block truncate animate-[slideUp_0.45s_cubic-bezier(0.16,1,0.3,1)] motion-reduce:animate-none"
      >
        {examples[index]}
      </span>
    </span>
  );
}
